<template>
  <div>
    <div class="row row-0">
      <div class="col-sm-6">
        <img src="../assets/images/section-1-hero.jpg" alt="" class="img-fluid img-full">
      </div>
      <div class="col-sm-6 align-middle">
        <div>
          <div id="section-1-content">
            <h3>
              Le Débit Différé :
              <br />L’essayer c’est l’adopter !
            </h3>
            <p>
              Pour gérer sereinement vos dépenses mensuelles réglées avec votre carte de paiement
              Crédit Agricole, choisissez le service Débit Différé<sup>(1)</sup>.
              Un service qui simplifie votre quotidien !
            </p>
            <p>
              <img src="../assets/images/cards.jpg" id="cards-picture" alt="" />
            </p>
            <p>
              <a
                :href="cta"
                class="the-button"
                target="_top"
                data-trackingclass="landing-page-clic-bouton"
                data-trackinginfo="landing-page-CAPS-debitdiffere-cta-rdv-haut"
              >
                Demandez le Débit Différé pour votre carte
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cta: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Hero.vue